module.exports = __webpack_public_path__ + "static/media/team_32_blue.dd14d039.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/team_32_blue.svg
// module id = 1383
// module chunks = 0